function log(msg, ...args) {
  //  console.log(msg, ...args)
}

module.exports = log;
